import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
	EmailFieldRHF,
	EnhancedCheckboxRHF,
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface ISystemAccessSetupFieldsPanel {
	employeeDDL: any
}
export const SystemAccessSetupFieldsPanel: FC<
	ISystemAccessSetupFieldsPanel
> = ({ employeeDDL }) => {
	return (
		<Box
		sx={{
        "& .MuiFormControlLabel-root": {
          marginBottom: "0!important",
          color: "rgba(0, 0, 0, 0.6)",
          fontSize: "0.875rem"
        },
        "& .MuiFormControlLabel-root .MuiTypography-root": {
          fontSize: "0.875rem"
        }
      }}
		>
			<EnhancedDropDownRHFWithLabel
				selectName={"accessLevel"}
				items={[
					{ label: "No Split", value: 100 }, // change
				]}
				label={"Access Level"}
				testId={"access-level"}
			/>

			<EnhancedDropDownRHFWithLabel
				selectName={"employeeId"}
				items={employeeDDL ?? []}
				selectedItem={"all"}
				label={"Employee"}
				testId={"employee-ddl"}
				showEmpty
			/>

			<RHookFormTextFieldWithLabel
				label="Name"
				id="firstName"
				testId={`first-name`}
				labelPosition={LabelPosition.Top}
			/>

			<RHookFormTextFieldWithLabel
				label="Last Name"
				id="lastName"
				testId={`last-name`}
				labelPosition={LabelPosition.Top}
			/>

			<EmailFieldRHF
				label="Email"
				id="email"
				testId={`email`}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			/>

			<EnhancedDropDownRHFWithLabel
				selectName="status"
				label="Status"
				labelPosition={LabelPosition.Top}
				testId={`status`}
				items={[
					{ label: "Active", value: 100 },
					{ label: "Inactive", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>

			<EnhancedCheckboxRHF
				name="SystemAccessThisScreen"
				checked={false}
				testId="System-Access-This-Screen"
				checkboxLabel="System Access (this) Screen"
			/>

			<EnhancedCheckboxRHF
				name="InvoiceAndBankReports"
				checked={false}
				testId="Invoice-And-Bank-Reports"
				checkboxLabel="Invoice and Bank Reports"
			/>

			<EnhancedCheckboxRHF
				name="CanSubmitDirectDepositEtc"
				checked={false}
				testId="Can-Submit-Direct-Deposit-Etc"
				checkboxLabel="Can submit direct deposit, etc"
			/>

			<EnhancedCheckboxRHF
				name="CanUnmaskEncryptedData"
				checked={false}
				testId="Can-Unmask-Encrypted-Data"
				checkboxLabel="Can unmask encrypted data"
			/>
		</Box>
	);
};
